import { Injectable, TemplateRef } from '@angular/core';
import { PdfPreviewTemplateOptions } from '@app/modules/pdf-request-form/pdf-request-form.types';

@Injectable()
export class PdfPreviewTemplateStateService {
  options: PdfPreviewTemplateOptions;
  pdfTemplate: TemplateRef<any>;
}
